module.exports = __webpack_public_path__ + "img/ai02.e7a8a01e.png";